import React from 'react';
import type {UnmountingTaskScheduler} from "@wix/devzai-utils-react";

export interface DoppeViewerPageApi {
    getUnmountingTaskScheduler(): UnmountingTaskScheduler;
}

export const DoppeViewerPageApiReactContext = React.createContext<DoppeViewerPageApi | null>(null);

